/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';

import MobileIwocaLogo from './MobileIwocaLogo';
import styles from './MobileNavigation.module.css';
import ApplicationInfo from '../ApplicationInfo';
import BurgerMenu from '../burgerMenu/BurgerMenu';

const MobileNavigation = ({}) => {
    return (
        <div className={styles.navigation} data-testid="navigation">
            <div className={styles.navigationContent}>
                <MobileIwocaLogo />
                <ApplicationInfo isMobile={true} />
            </div>
            <BurgerMenu isMobile={true} />
        </div>
    );
};

export default MobileNavigation;
